export const workspace = {
  routes: [
    {
      path: "/",
      component: () => import("@/modules/workspace/dashboard"),
    },
    {
      path: "edit",
      component: () => import("@/modules/workspace/workspace-form"),
    },
    {
      path: "workspaces",
      component: () => import("@/modules/workspace/my-workspaces-view"),
    },
    // {
    //   path: "create",
    //   component: () => import("@/modules/workspace/create-workspace-view"),
    // },
    {
      path: "organizations",
      component: () => import("@/modules/workspace/workspace-organizations-view"),
    },
    {
      path: "members",
      component: () => import("@/modules/workspace/workspace-members-view"),
    },
    {
      path: "member/:memberId",
      component: () => import("@/modules/workspace/workspace-member-info-view"),
    },
  ],
};
